import { Component, OnInit } from "@angular/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { TranslateModule } from "@ngx-translate/core";
import { TableComponent } from "src/app/components/default/table/table.component";
import { getTableGroupAmount } from "src/helpers/getTableGroupAmount";
import { DialogTitle } from "../../template/dialog-template.component";
import { DialogComponent } from "../dialog.component";

export interface TableFilterDialogData {
  tableInstance: TableComponent;
  title?: DialogTitle;
}

@Component({
  selector: "app-table-filter-dialog",
  imports: [MatCheckboxModule, TranslateModule],
  templateUrl: "./table-filter-dialog.component.html",
  styleUrl: "./table-filter-dialog.component.less",
})
export class TableFilterDialogComponent extends DialogComponent<TableFilterDialogData> implements OnInit {
  public levelcounts: Record<string, number> = {};
  public filtercounts: Record<string, number> = {};

  public ngOnInit(): void {
    super.ngOnInit();
    if (this.data) {
      const groups = this.data.tableInstance.getAllGroups();
      const filters = this.data.tableInstance.filters;

      for (const level of filters) {
        let levelcount = 0;
        for (const filter of level.filters) {
          const group = groups.find((x) => x.level === level.level && x.label === filter.value);
          if (!group) continue;
          const count = getTableGroupAmount(group).total;
          levelcount += count;
          this.filtercounts[`${level.level}|${filter.value}`] = count;
        }
        this.levelcounts[level.level] = levelcount;
      }
    }
  }
}
